export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12820.18116ab3.jpg";